import { useCallback } from 'react';
import { actions as ordersActions } from 'state/orders';
import { useDispatch } from 'react-redux';
import { replace } from 'connected-react-router';
import routes from 'utils/routes';

export default function useNavigateToMainPage() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(ordersActions.resetData());
    dispatch(replace(routes.orders.default));
  }, [dispatch]);
}
